import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ICON_SIZE } from '../../constants';
import { getIconColor, getIconHoverColor } from '../../helpers/icons';
import SvgIcon from '../../SvgIcon';
import styled from 'styled-components';
import { getPx } from '../../helpers';
import { INPUT_HORIZONTAL_PADDING } from '../constants';
const StyledIndicatorIcon = styled(SvgIcon)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: ${getPx(INPUT_HORIZONTAL_PADDING)};
  ${({
  open
}) => open && `
    svg {
      transform: rotate(180deg);
    }
  `}
`;
const DropdownIndicatorIcon = /*#__PURE__*/React.forwardRef(({
  isDisabled,
  isRotated,
  icon,
  ...props
}, forwardedRef) => /*#__PURE__*/React.createElement(StyledIndicatorIcon, _extends({
  ref: forwardedRef,
  pointer: !isDisabled,
  color: getIconColor(isDisabled),
  colorHover: getIconHoverColor(isDisabled),
  size: ICON_SIZE,
  open: isRotated
}, props), icon));
export default DropdownIndicatorIcon;